import React, {useEffect, useState} from 'react'
import {getByIdResource, updateResource} from "../../service/http-service";
import {Combo} from "../../ui/Combo";
import './ProfileFormsStyle.css'
import FormHeader from '../../../assets/img/profile-images/form-header.png'

export const ProfileFieldOfInterestForm = ({entityTemp,setEntityTemp,title,updateEntity,setUpdateEntity, setAddEntity}) => {

    const [entity, setEntity] = useState()

    const [fieldsOfInterests, setFieldsOfInterests] = useState([])
    const [showError, setShowError] = useState(false)


    useEffect (() => {
        setEntity(entityTemp);
        if (entityTemp.candidate) {
            getByIdResource('fields_of_interest/get_by_candidate', entityTemp.candidate.id).then((data) => {
                console.log(data.data)
                setFieldsOfInterests(data.data)
            })
        }
    }, []);


    return (

            <div className="background-form col-12 p-0">
                {(entity) && (<>
                        <img src={FormHeader} className="form-header-image"/>
                        <div className="profile_add_button form-button-title">{title}</div>
                        <form className="col-lg-10 offset-lg-1">
                            {(fieldsOfInterests && fieldsOfInterests.length > 0) &&
                                (
                                    <Combo
                                        tooltipText="Одберете поле на интерес"
                                        comboClass="combo-form"
                                        placeholder="Поле на интерес"
                                        onChange={(e) => {
                                            let chosenFieldOfInterest = {};
                                            chosenFieldOfInterest.id = e.target.value;
                                            setEntity({ ...entity, fieldOfInterest: chosenFieldOfInterest })
                                            setShowError(false)
                                        }}
                                        onClear={() => setEntity({...entity, fieldOfInterest:null})}
                                        array={fieldsOfInterests}/>)}

                            {showError && <b>Ве молиме одберете поле на интерес</b>}

                            <div className="col-12 d-flex justify-content-between">
                                <div
                                    className="btn-form"
                                    onClick={()=>
                                    {setAddEntity(false)
                                        setEntityTemp({candidate: entity.candidate})
                                    }}
                                >Затвори</div>
                                <div
                                    className="btn-form"
                                    onClick={(e) => {
                                        if(entity.fieldOfInterest && entity.fieldOfInterest.id !== "0"){
                                            updateResource('candidates_fields_of_interest', entity)
                                                .then((data) => {
                                                    console.log(data.data)
                                                    setAddEntity(false)
                                                    setEntityTemp({candidate: entity.candidate})
                                                    setUpdateEntity(!updateEntity)
                                                    setShowError(false);
                                                })
                                        } else {
                                            setShowError(true)
                                        }
                                    }}
                                >Зачувај</div>
                            </div>
                        </form>
            </>
            )
                }
        </div>
    )
}